var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group input-group", staticStyle: { width: "100%" } },
      [
        _c(
          "span",
          {
            staticClass: "input-group-addon",
            staticStyle: { background: "white", width: "140px" }
          },
          [_c("span", [_vm._v(_vm._s(_vm.title))])]
        ),
        _vm._v(" "),
        _vm.type === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.storeData,
                  expression: "storeData"
                }
              ],
              staticClass: "form-control",
              staticStyle: { "z-index": "0" },
              attrs: {
                type: "username",
                placeholder: _vm.placeholder,
                type: "checkbox"
              },
              domProps: {
                checked: Array.isArray(_vm.storeData)
                  ? _vm._i(_vm.storeData, null) > -1
                  : _vm.storeData
              },
              on: {
                change: function($event) {
                  var $$a = _vm.storeData,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.storeData = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.storeData = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.storeData = $$c
                  }
                }
              }
            })
          : _vm.type === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.storeData,
                  expression: "storeData"
                }
              ],
              staticClass: "form-control",
              staticStyle: { "z-index": "0" },
              attrs: {
                type: "username",
                placeholder: _vm.placeholder,
                type: "radio"
              },
              domProps: { checked: _vm._q(_vm.storeData, null) },
              on: {
                change: function($event) {
                  _vm.storeData = null
                }
              }
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.storeData,
                  expression: "storeData"
                }
              ],
              staticClass: "form-control",
              staticStyle: { "z-index": "0" },
              attrs: {
                type: "username",
                placeholder: _vm.placeholder,
                type: _vm.type
              },
              domProps: { value: _vm.storeData },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.storeData = $event.target.value
                }
              }
            })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74aeb6c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aeb6c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/textInput.vue
// module id = 142
// module chunks = 0